import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import {
  ContentIsland,
  Grid,
  ListContentIsland,
  Stack,
  GraphicsDuckImage,
  Typography,
  SkeletonListItem,
  Skeleton,
  Box,
  ErrorListItem,
} from '@razz-team/ui-web';
import { useTransactionsInfinityQuery } from '../../../api/transactions';
import { TransactionsFilters } from './TransactionsFilters';
import { Route } from '../../../routes/account.transactions';
import { PagedTransactionsList } from './PagedTransactionsList';
import { useCallback } from 'react';

export function TransactionsPage() {
  const { t } = useTranslation();
  const search = Route.useSearch();
  const transactionsQuery = useTransactionsInfinityQuery(search);
  const { hasNextPage, isFetchingNextPage, fetchNextPage } = transactionsQuery;

  const handleScrollRatioChange = useCallback(
    (ratio: number) => {
      if (ratio >= 2 / 3 && hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    },
    [hasNextPage, isFetchingNextPage, fetchNextPage],
  );

  return (
    <MainLayout title={t('Transactions')} onScrollRatioChange={handleScrollRatioChange}>
      <Grid size={12}>
        <TransactionsFilters />
      </Grid>
      <Grid size={12}>
        {transactionsQuery.isPending ? (
          <ListContentIsland>
            <Box sx={{ mx: 4, my: 3 }}>
              <Skeleton variant="rounded" height={12} width={48} />
            </Box>
            <SkeletonListItem variant="transaction" sx={{ height: '56px' }} />
            <SkeletonListItem variant="transaction" sx={{ height: '56px' }} />
          </ListContentIsland>
        ) : transactionsQuery.isError ? (
          <ListContentIsland>
            <ErrorListItem error={transactionsQuery.error} />
          </ListContentIsland>
        ) : transactionsQuery.data.pages?.[0].transactions.length ? (
          <PagedTransactionsList pages={transactionsQuery.data.pages} />
        ) : (
          <ContentIsland sx={{ paddingY: '48px' }}>
            <Stack direction="column" alignItems="center" spacing={4}>
              {__BRIGHTY__ ? <GraphicsDuckImage width={120} height={120} /> : null}
              <Typography color="text.secondary">{t('Nothing found')}</Typography>
            </Stack>
          </ContentIsland>
        )}
      </Grid>
    </MainLayout>
  );
}
